import React from 'react';

import StageBadge from 'bundles/apex/deals/stages/badge';
import { LinkCard, getCardPaths } from './link_card';

import type { Deal } from 'bundles/apex/deals/types';
import type { DealToolCall } from '../types';

interface DealCardsProps {
  toolCalls: DealToolCall[];
}

export function DealCards({ toolCalls }: DealCardsProps) {
  return (
    <>
      {getCardPaths(toolCalls).map(path => (
        <LinkCard key={path} path={path}>
          {(deal: Deal) => (
            <>
              <div className="fw-semibold text-truncate">{deal.displayName}</div>
              <StageBadge className="d-inline-flex" stage={deal.stage} stageLabel={deal.stageLabel} />
            </>
          )}
        </LinkCard>
      ))}
    </>
  );
}
